<template>
  <div class="ess" :class="{ 'is-stretch': isStretch }">
    <div class="ess__stretch" v-if="false">
      <div class="ess__stretch-btn" @click="isStretch = !isStretch">
        <el-icon class="ess__stretch-icon">
          <CaretLeft/>
        </el-icon>
      </div>
    </div>
    <div class="ess__aside" v-if="false">
      <el-tree :data="tree" :default-expand-all="true"></el-tree>
    </div>
    <div class="ess__container" v-if="units.length > 0">
      <div class="ess__main" ref="essMain">
        <div class="ess-cabe">
          <div class="ess-cabe__text">10kv {{ $str.getKey('数据可视化/母线') }}</div>
        </div>

        <div class="ess-unit-wrap" :class="{ 'one': units.length === 1 }" ref="unitWrap">
          <div class="ess-unit" :class="{ 'one': units.length === 1 }" v-for="unit in units" :key="unit.unitId">
            <div class="ess-transformer">
              <div class="ess-line down"></div>
              <div class="ess-transformer-box">
                <img src="@/assets/images/topo/ic_transformer.png" height="24" alt="" srcset="">
                <span class="ess-node-text">{{ unit.unitName }}</span>
              </div>
              <EssGatewayMeter :gatewayMeter="unit.gatewayMeter" />
            </div>

            <div class="ess-cabe ess-cabe--380">
              <div class="ess-cabe__text">380v {{ $str.getKey('数据可视化/母线') }}</div>
            </div>

            <div class="ess-meter-parallel">
              <EssPayload :eLinks="unit.eLinks"/>
              <div class="ess-meter-parallel-box" v-for="eLink in unit.eLinks" :key="eLink.id">
                <EssCombinedMeter :combinedMeter="eLink.combinedMeter" />
                <EssELink :data="eLink" />

                <div class="ess-eblock-wrap" :class="{ 'shrink': eLink.open }">
                  <el-badge :value="eLink.eBlocks.length" type="primary" class="ess-shrink-badge"
                    :hidden="!eLink.open || !eLink.eBlocks.length">
                    <div class="ess-shrink-box" @click="eLink.open = !eLink.open"></div>
                  </el-badge>
                  <div class="ess-cabe ess-cabe--380 ess-cabe--eblock">
                    <div class="ess-cabe__text">380v {{ $str.getKey('数据可视化/母线') }}</div>
                  </div>
                  <div class="ess-eblock-list">
                    <EssEBlock :data="eBlock" v-for="eBlock in eLink.eBlocks" :key="eBlock.id" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-empty class="ess__empty" :image-size="60" v-else></el-empty>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount, inject } from "vue"
import useAppStore from "@/store/modules/app"
import { ws_req } from "@/ws/wss-request"
import { v2 as apiV2 } from "@/api/device/station"
import { ESSTree, UnitNode, ELinkNode, EBlockNode } from './ess-tree'
import { CaretLeft } from "@element-plus/icons-vue"

import EssEBlock from './EssEBlock.vue'
import EssELink from './EssELink.vue'
import EssPayload from './EssPayload.vue'
import EssGatewayMeter from './EssGatewayMeter.vue'
import EssCombinedMeter from './EssCombinedMeter.vue'
import { useStationContext } from '@/views/station-monitor/detail/composables/useStationContext'


const $str = window.$str

// Props
const props = defineProps({
  // 如果有props可以在这里定义
})

// Inject
// const activeStation = inject('activeStation')

// Store
// const appStore = useAppStore()

// Refs
const essMain = ref(null)
const unitWrap = ref(null)
const ebTimer = ref(null)

// Data
const tree = ref([])
const units = ref([])
const isStretch = ref(false)

// Computed
// const computedActiveStation = computed(() => activeStation())
// const stationName = computed(() => computedActiveStation.value.name)
// const stationId = computed(() => computedActiveStation.value.stationId)
const { stationId, stationName, stationBaseData } = useStationContext()
const uuids = computed(() => {
  const ids = []
  units.value.forEach(unit => {
    if (unit.gatewayMeter?.uuid) {
      ids.push(unit.gatewayMeter.uuid)
    }
    unit.eLinks?.forEach(eLink => {
      if (eLink.combinedMeter?.uuid) {
        ids.push(eLink.combinedMeter.uuid)
      }
      ids.push(eLink.uuid)
      eLink.eBlocks?.forEach(eBlock => {
        ids.push(eBlock.uuid)
      })
    })
  })
  return ids
})

// Methods
const setStretch = () => {
  const value = localStorage.getItem('eMind.is_stretch')
  if (value != null) {
    isStretch.value = JSON.parse(value)
  }
}

const setSize = () => {
  if (!essMain.value) return
  
  essMain.value.style.width = '0'
  setTimeout(() => {
    const targetNode = unitWrap.value
    if (targetNode?.children.length > 1) {
      let width = 0
      for (const child of targetNode.children) {
        width += child.getBoundingClientRect().width
      }
      console.log('w', width)
      essMain.value.style.width = width + 'px'
    } else {
      essMain.value.style.width = 'auto'
    }
  }, 200)
}

const fixData = (unitsData = []) => {
  unitsData.forEach(unit => {
    if (unit.eLinks == null) {
      unit.eLinks = []
    }
    if (unit.gatewayMeter == null) {
      unit.gatewayMeter = { data: {} }
    }
    unit.eLinks.forEach(eLink => {
      eLink.open = false
      eLink.data = {}
      if (eLink.eBlocks == null) {
        eLink.eBlocks = []
      }
      if (eLink.combinedMeter == null) {
        eLink.combinedMeter = { data: {} }
      }
      eLink.eBlocks.forEach(eBlock => {
        eBlock.data = {}
      })
    })
  })
  return unitsData
}

const getDevices = async () => {
  const res = await apiV2.getDevicesById(stationId.value)
  const fixedUnits = fixData(res.data.list)
  const essTree = transformToTree(fixedUnits)
  tree.value = [essTree.root]
  units.value = fixedUnits
}

const setEBData = (dataList) => {
  const fondEBByUUID = (uuid) => {
    for (const unit of units.value) {
      for (const eLink of unit.eLinks) {
        for (const eBlock of eLink.eBlocks) {
          if (eBlock.uuid === uuid) {
            return eBlock
          }
        }
      }
    }
  }
  
  Object.keys(dataList).forEach(uuid => {
    const findedEb = fondEBByUUID(uuid)
    if (findedEb) {
      findedEb.data = dataList[uuid]
    }
  })
}

const setELKData = (dataList) => {
  const foundById = (uuid) => {
    for (const unit of units.value) {
      for (const eLink of unit.eLinks) {
        if (eLink.uuid === uuid) {
          return eLink
        }
      }
    }
  }

  Object.keys(dataList).forEach(uuid => {
    const findedELK = foundById(uuid)
    if (findedELK) {
      findedELK.data = dataList[uuid]
    }
  })
}

const setMeterData = (dataList) => {
  const foundById = (uuid) => {
    for (const unit of units.value) {
      const meterUUID = unit.gatewayMeter?.uuid
      if (uuid === meterUUID) {
        return unit.gatewayMeter
      } else {
        for (const eLink of unit.eLinks) {
          const meterUUID = eLink.combinedMeter?.uuid
          if (meterUUID === uuid) {
            return eLink.combinedMeter
          }
        }
      }
    }
  }

  Object.keys(dataList).forEach(uuid => {
    const foundedMeter = foundById(uuid)
    if (foundedMeter) {
      foundedMeter.data = dataList[uuid]
    }
  })
}

const transformToTree = (unitsData = []) => {
  const essTree = new ESSTree(stationName.value)
  unitsData.forEach(elem => {
    const unit = new UnitNode(elem.unitName)
    elem.eLinks.forEach(eLink => {
      const eLinkNode = new ELinkNode(eLink.eLinkName)
      eLink.eBlocks.forEach(eBlock => {
        const eBlockNode = new EBlockNode(eBlock.eBlockName)
        eLinkNode.addEBlock(eBlockNode)
      })
      unit.addELink(eLinkNode)
    })
    essTree.addUnit(unit)
  })
  return essTree
}

const getRealData = async (recurs, interval = 5000) => {
  try {
    if (stationId.value) {
      const real_data = await ws_req.request('ws_device_diagram', {
        stationId: stationId.value
      })

      console.log({ real_data })

      setEBData(real_data.eblock_data_list)
      setELKData(real_data.elink_data_list)
      setMeterData(real_data.meter_data_list)
    }

    if (recurs) {
      ebTimer.value = setTimeout(() => {
        getRealData(recurs, interval)
      }, interval)
    }
  } catch (error) {
    console.warn(error)
  }
}

// Watch
watch(stationId, async () => {
  console.log('---station id change---', stationId.value)
  if (stationId.value) {
    await getDevices()
    await getRealData(false)
  }
})

watch(isStretch, (value) => {
  localStorage.setItem('eMind.is_stretch', value)
})

// Lifecycle
onMounted(() => {
  setStretch()
  
  const waitStationIdReady = (callback) => {
    setTimeout(() => {
      if (!stationId.value) {
        waitStationIdReady(callback)
      } else {
        callback(stationId.value)
      }
    }, 200)
  }

  waitStationIdReady(async (sid) => {
    await getDevices()
    await getRealData(true)
  })
})

onBeforeUnmount(() => {
  if (ebTimer.value) {
    clearTimeout(ebTimer.value)
  }
})

// Expose methods if needed
defineExpose({
  setSize,
  getDevices,
  getRealData
})
</script>

<style scoped>
/* 保持原有样式不变 */
</style>
